import {Utils} from 'hasta-la-vista-ui-core'
import {RegionService, MovieMetaService, MovieService, AuthService} from 'hasta-la-vista-middleware-api/service'
import DatePicker from 'vue2-datepicker';
import moment from 'moment'

export default {
    components: {
        DatePicker
    },
    props: {
        form_data: Object,
        search_filter: Object,
        doSearch: Boolean,
        availableCinemas: {type: Array, default: []},
        cinemasByRegion: Array,
        timeRanges: Array,
        dates: Array,
        cinemaTypes: Array,
        movieGenres: Array,
        filterOptions: Array,
        loading: Boolean,
        isNouveau: Boolean,
        predictiveText: Array,
        searchResultCount: Number,
        availableDates: Array,
    },

    data () {
        return {
            last_form_data: {},
            resetVal: null,
            cinemasNearBy: [],
            cinemas_data: [],
            search: 'sandton',
            filterSelects: [],
            typeSelects: [],
            genreSelects: [],
            cinemaType: [],
            regionsByLabel: [],
            place: null,
            isLoading: true,
            regions: [],
            search_query: null,
            cinemaActive: false,
            filterActive: false,
            cinemasFiltered: null,
            movies: [],
            cinemas_by_region: [],
            cinemaSelectLoading: false,
            created: true,
            genreSearchable: true,
            typeSearchable: true,
            mobile_cinema_types: [],
            mobile_genres: [],
            mobile_time_range: null,
            mobile_dates: null,
            selected_cinema: null,
            selected_time_range: null,
            selected_types: null,
            movieDatePickerOpen: false,
        }
    },

    computed: {
        filter() {
            let result = {
                title: null,
                cinemas: null,
                genres: null,
                experiences: null,
                dates: this.form_data.dates,
            }

            if (this.form_data.selected_cinema != null && this.form_data.selected_cinema != undefined) {
                result.cinemas = this.form_data.selected_cinema
            }

            return result
        },

        selectedCinema() {
            return {
                name: this.form_data.selected_cinema && this.form_data.selected_cinema.name ? this.form_data.selected_cinema.name : undefined,
                id: this.form_data.selected_cinema && this.form_data.selected_cinema.id ? this.form_data.selected_cinema.id : undefined,
            }
        },

        selectedOptions() {
            if (this.form_data != undefined && this.form_data != null) {
                if (this.form_data.selected_cinema != undefined && this.form_data.selected_cinema != null) {
                    if (this.form_data.selected_cinema.id != undefined && this.form_data.selected_cinema.id != null) {
                        this.selected_cinema = this.form_data.selected_cinema
                    }
                }

                if (this.form_data.cinema_types != undefined && this.form_data.cinema_types != null) {
                    this.selected_types = this.form_data.cinema_types
                }
            }

            return this.form_data
        }
    },

    methods: {
        placeSelected: function (place) {
            this.place = place;
            this.getClosestCinema('cinemas/:latitude/:longitude')
        },

        getClosestCinema () {
            RegionService.getCinemasNearBy(this.place.latitude, this.place.longitude).then((cinemasNearBy)=> {
                    cinemasNearBy = cinemasNearBy.filter((c)=>~this.availableCinemas.indexOf(c.id.toString()))

                    this.cinemasNearBy = cinemasNearBy;
                    this.$emit("setCinemasNearby", this.cinemasNearBy)
                }
            );
        },

        resetForm() {
            this.form_data.place_query = null;
            this.form_data.keyword = null;
            this.form_data.selected_cinema = {};
            this.form_data.filter_group = null;
            this.form_data.cinema_types = null;
            this.form_data.genres = null;
            this.form_data.selected_time_range = null;
            this.form_data.dates = null;

            this.selected_time_range = null;
            this.mobile_cinema_types = null;
            this.mobile_genres = null;
            this.mobile_time_range = null;
            this.selected_types = null;
            this.selected_cinema = null;
            this.cinemaActive = false
            this.filterActive = false

            this.$emit('changed', this.filter)
        },

        nouveauFilter() {
            if (this.$route.path === '/nouveau') {
                this.filterSelects.shift()
                this.form_data.filter_group = [{name: 'Nouveau'}]
            } else {
                if (this.filterSelects.length < 2) this.filterSelects.unshift(this.cinemaType)
                this.form_data.filter_group = []
            }
        },

        generateSelectedRouteCinemaTypes(route_types) {
            let selected_cinema_types = [];

            if (typeof route_types === 'string') {
              if (route_types && route_types.length > 0) {
                  for (let r in route_types) {
                      if (route_types[r] != undefined) {
                        let rtype = route_types[r].split("-").join(" ")

                        selected_cinema_types.push({name: rtype.trim()})
                      }
                  }
              }
            }

            return selected_cinema_types
        },

        setDisabledDates(date) {
            // check if date is in the past
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            if (date < today) {
                return true;
            }

            const calendarDate = moment(date).format('YYYY-MM-DD');

            if (this.availableDates.indexOf(calendarDate) > -1) {
                return false;
            }

            return true;
        },
    },


    created () {
        this.form_data.doInitialSearch = true;
    },

    watch: {
        form_data: {
            handler: Utils.debounce(function () {
                  this.$emit('changed', this.filter)
            }, 300),
            deep: true
        },

        selected_cinema: {
            handler: Utils.debounce(function() {
                let empty_cinema = null

                if (this.selected_cinema != null) {
                  this.form_data.selected_cinema = this.selected_cinema
                } else {
                  this.form_data.selected_cinema = empty_cinema
                }

                this.form_data.count++
            }, 300)
        },

        selectedOptions: {
           handler: Utils.debounce(function() {
              return true
           }, 300)
        },

        selected_types: {
            handler: Utils.debounce(function() {
                if (this.selected_types != null && this.selected_types != undefined) {
                    this.form_data.cinema_types = this.selected_types
                } else {
                    this.form_data.cinema_types = null
                }

                this.form_data.count++
            }, 300)
        },

        mobile_cinema_types: {
            handler: Utils.debounce(function() {
                if (this.mobile_cinema_types != null && this.mobile_cinema_types != undefined) {
                    if (this.mobile_cinema_types.length > 0) {
                        let cinema_types = []

                        for (let mt in this.mobile_cinema_types) {
                            if (this.mobile_cinema_types[mt] != undefined && this.mobile_cinema_types[mt] != null) {
                                for (let t in this.mobile_cinema_types[mt]) {
                                    if (this.mobile_cinema_types[mt][t]) {
                                        cinema_types.push(this.mobile_cinema_types[mt][t])
                                    }
                                }
                            }
                        }

                        if (cinema_types.length > 0) {
                            this.form_data.cinema_types = cinema_types
                        } else {
                            this.form_data.cinema_types = null
                        }

                        this.form_data.count++
                    }
                }
           })
        },

        mobile_genres: {
            handler: Utils.debounce(function() {

                if (this.mobile_genres != null) {
                    if (this.mobile_genres.length > 0 && this.mobile_genres != this.form_data.genres) {

                        let genres = []

                        for (let mg in this.mobile_genres) {
                            if (this.mobile_genres[mg]) {
                                for (let g in this.mobile_genres[mg]) {
                                    if (this.mobile_genres[mg][g]) {
                                        genres.push(this.mobile_genres[mg][g])
                                    }
                                }
                            }
                        }

                        if (genres.length > 0) {
                            this.form_data.genres = genres
                        } else {
                            this.form_data.genres = null
                        }

                        this.form_data.count++
                    }
                }
            })
        },

        '$route' (to, from) {
            this.nouveauFilter()
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/generic/search-filter/search-filter.js